import {
  faBook,
  faChartBar,
  faBullhorn,
  faLightbulb,
  faGavel,
  faShield,
} from '@awesome.me/kit-e270131d0a/icons/classic/regular'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export interface HelpMenuItem {
  id: string
  name: string
  url: string
  icon?: IconDefinition
  group: string
}

export const HELP_MENU_ITEMS: HelpMenuItem[] = [
  {
    id: 'knowledge-base',
    name: 'Knowledge Base',
    url: 'https://help.saasalerts.kaseya.com/help/Content/Home/Home.htm',
    icon: faBook,
    group: 'Help',
  },
  {
    id: 'ideas-portal',
    name: 'Ideas Portal',
    url: 'https://community.kaseya.com/private/login',
    icon: faLightbulb,
    group: 'Help',
  },
  {
    id: 'status',
    name: 'Status',
    url: 'https://status.saasalerts.com/',
    icon: faChartBar,
    group: 'Help',
  },
  {
    id: 'changelog',
    name: 'Changelog',
    url: 'https://help.saasalerts.kaseya.com/help/Content/Home/release-notes/release-notes.htm',
    icon: faBullhorn,
    group: 'Help',
  },
  {
    id: 'legal-terms',
    name: 'Terms of Use',
    url: 'https://www.kaseya.com/legal/',
    icon: faGavel,
    group: 'Legal',
  },
  {
    id: 'privacy',
    name: 'Privacy Statement',
    url: 'https://www.kaseya.com/legal/kaseya-privacy-statement/',
    icon: faShield,
    group: 'Legal',
  },
]
